const n = "subline", t = "subline__avatar", e = "subline__author", i = "subline__date", s = {
  subline: n,
  "subline__attribution-phrase": "subline__attribution-phrase",
  "subline__author-container": "subline__author-container",
  subline__avatar: t,
  "subline__author-description-container": "subline__author-description-container",
  subline__author: e,
  "subline__author-description": "subline__author-description",
  subline__date: i
};
export {
  s as default,
  n as subline,
  e as subline__author,
  t as subline__avatar,
  i as subline__date
};
